import { requestKarangoApi } from "../api/karangoTransport";

export async function sendBrandedVerificationEmail(firebaseUser) {
  return requestKarangoApi("/v1/auth/email-verification", {
    method: "POST",
    requiresAuth: true,
    // Un timeout apres acceptation par Resend a un resultat ambigu. Rejouer
    // toute la route genererait un nouveau lien et pourrait doubler l'envoi.
    retryable: false,
    firebaseUser,
  });
}

// « Mot de passe oublie » envoye par notre service d'e-mail (expediteur
// Karango) plutot que par l'expediteur generique de Firebase, souvent filtre
// (docs/password-reset-email-spec.md). Reponse neutre : jamais d'indication
// sur l'existence du compte.
export async function sendBrandedPasswordResetEmail(email) {
  return requestKarangoApi("/v1/auth/password-reset", {
    method: "POST",
    requiresAuth: false,
    body: { email },
    retryable: false,
  });
}

// Demande de nouveau mot de passe : notre envoi d'abord ; repli sur l'envoi
// standard de Firebase si notre serveur est injoignable ou en panne. Trop de
// demandes ou adresse invalide : erreur explicite, aucun autre envoi.
export async function requestPasswordReset(email, { sendBranded = sendBrandedPasswordResetEmail, sendFirebase }) {
  try {
    await sendBranded(email);
  } catch (error) {
    if (error?.status === 429) {
      throw Object.assign(new Error("Trop de demandes. Réessaie dans un moment."), { code: "auth/too-many-requests" });
    }
    if (error?.status === 400) {
      throw Object.assign(new Error("Adresse e-mail invalide."), { code: "auth/invalid-email" });
    }
    await sendFirebase(email);
  }
}
